import type { FieldInputProps } from 'formik';

import {
  ArrowLeftAndRightIcon,
  ArrowUpAndDownIcon,
  FormControl,
  FormLabel,
  Select,
  Text,
} from '@frontend/components';
import { isObject } from '@frontend/utils';

import type {
  NestingSelectOption,
  NestingDefaultsData,
  FormInputProps,
} from '.';

export const AlongLengthOption = () => {
  return (
    <Text>
      Along Length <ArrowLeftAndRightIcon />
    </Text>
  );
};
export const AlongWidthOption = () => {
  return (
    <Text>
      Along Width <ArrowUpAndDownIcon />
    </Text>
  );
};

export const NESTING_DIRECTION_OPTIONS = [
  { label: 'Maximize Utilization', value: '' },
  {
    label: <AlongLengthOption />,
    value: 'X',
  },
  {
    label: <AlongWidthOption />,
    value: 'Y',
  },
];

type NestingDirectionFieldProps = {
  field: FieldInputProps<string | null>;
  form: FormInputProps<NestingDefaultsData>;
  isSubmitting: boolean;
};

export const NestingDirectionField = ({
  field,
  form,
  isSubmitting,
}: NestingDirectionFieldProps) => {
  return (
    <FormControl isReadOnly={isSubmitting}>
      <FormLabel fontWeight={600}>Nesting Direction</FormLabel>
      <Select
        value={
          isObject(field.value)
            ? field.value
            : NESTING_DIRECTION_OPTIONS.find(
                (opt) => field.value === opt.value,
              ) ?? ''
        }
        aria-label="Nesting Direction Dropdown"
        onChange={(opt: NestingSelectOption) => {
          form.setFieldValue('nestingDirection', opt.value, false);
        }}
        isClearable={false}
        isDisabled={isSubmitting}
        options={NESTING_DIRECTION_OPTIONS}
      />
    </FormControl>
  );
};
